angular
  .module('contabilidad.polizas')
  .service('pagosNominasUSDService', pagosNominasUSDService)

pagosNominasUSDService.$inject = ['$api', '$filter', '$schema']

function pagosNominasUSDService ($api, $filter, $schema) {
  this.obtenerInformacionPagosNominaUSD = obtenerInformacionPagosNominaUSD
  this.codificarPagosNominaUSD = codificarPagosNominaUSD

  function obtenerInformacionPagosNominaUSD (ids_nominas, tipo_poliza) {
    return $api.get('/kendu/contabilidad/polizas/polizasPagosNominaUSD', {
      ids_Nominas: ids_nominas,
      tipo_poliza: tipo_poliza,
    }).then(function (data) {
      return data.map(function (item) {
        return $schema(item, {
          Ingreso: 'number',
          Comision: 'number',
          Deudor: 'number',
          Total: 'number',
          Diferencia: 'number',
          Importe: 'number',
          Importe_Pago: 'number',
          Importe_Provision: 'number',
        })
      })
    })
  }

  var verificarCadena = $filter('rPad')

  function codificarPagosNominaUSD (data, inicio_poliza) {
    var cadenaPrincipal = '',
      cadA = 'P  AAAAMMDD    +      JJJJ 1 0          ' +
        'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\\n',
      cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0' +
        '                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \\n',

      fechaA,
      fechaB,
      cheque
    try {
      data.forEach(function (item) {

        fechaA = $filter('date')(item.Fecha, 'yyyyMMdd')
        fechaB = verificarCadena(item.ID_Nomina, 15)
        cheque = verificarCadena(item.Forma_Pago === '02' && item.Referencia.indexOf('a') === -1 ? 'CH-' + item.Referencia : fechaB, 15)

        cadenaPrincipal += cadA
          .replace('AAAAMMDD', fechaA)
          .replace('+', item.Forma_Pago === '01' ? '2' : '2')
          .replace('JJJJ', ('0000' + inicio_poliza).slice(-4))
          .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', verificarCadena('PAGOS DE NOMINA USD', 60))

        if (item.Tipo_Moneda === '2' && item.Moneda === '1') {
          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena((item.Cuenta_Contable_Deudor !== '' ? item.Cuenta_Contable_Deudor : item.Cta_MXN).replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', cheque)
            .replace('*', 1)
            .replace('YYYYYYYYY', verificarCadena(item.Importe_Provision.toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((item.ID_Nomina), 43))
        }

        if (item.Tipo_Moneda === '2' && item.Moneda === '2' && item.Cuenta_Contable_Deudor !== '') {
          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable_Deudor.replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', cheque)
            .replace('*', 1)
            .replace('YYYYYYYYY', verificarCadena(item.Importe_Pago.toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((item.ID_Nomina), 43))
        }

        if (item.Diferencia > 0 && item.Tipo_Moneda === '2' && item.Moneda === '1') {
          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cta_UtildadPerdidaCambiaria.replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', fechaB)
            .replace('*', item.Tipo_Movimiento === 'C' ? 0 : 1)
            .replace('YYYYYYYYY', verificarCadena(item.Diferencia.toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((item.ID_Nomina), 43))
        }

        if (item.Diferencia > 0 && item.Cuenta_Contable_Deudor === '' && item.Tipo_Moneda === '2' && item.Moneda === '2') {
          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cta_UtildadPerdidaCambiaria.replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', fechaB)
            .replace('*', item.Tipo_Movimiento === 'C' ? 0 : 1)
            .replace('YYYYYYYYY', verificarCadena(item.Diferencia.toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((item.ID_Nomina), 43))
        }

        if (item.Tipo_Moneda === '2' && item.Moneda === '2' && item.Cuenta_Contable_Deudor === '') {
          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable.replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', cheque)
            .replace('*', 1)
            .replace('YYYYYYYYY', verificarCadena(item.Total_Dolares.toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((item.ID_Nomina), 43))
        }

        if (item.Tipo_Moneda === '2' && item.Moneda === '2' && item.Cuenta_Contable_Deudor === '') {
          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable_Complementaria.replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', cheque)
            .replace('*', 1)
            .replace('YYYYYYYYY', verificarCadena((item.Importe_Provision - item.Total_Dolares).toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((item.ID_Nomina), 43))
        }

        item.hijos.forEach(function (ele) {

          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena('2100050000000000', 16))
            .replace('ZZZZZZZZZZZZZZZ', fechaB)
            .replace('*', 0)
            .replace('YYYYYYYYY', verificarCadena(ele.Importe_Pago.toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((ele.ID_Nomina + ' ' + ele.Nombre), 43))

        })

        inicio_poliza++
      })

      return cadenaPrincipal
    } catch (err) { // try
      return 'Error'
    }
  }

}




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/services/pagosNominasUSDService.js